// const WEBAPI_LOCALHOST_URL = 'https://webapi.testing.budbee.com'
const WEBAPI_LOCALHOST_URL = 'http://localhost:9000'

const GROUND_OPS_ADMIN_LOCALHOST_URL = 'http://localhost:3000'

const SHOPPING_BACKOFFICE_LOCALHOST_URL = 'http://localhost:3000'

/**
 * A regex to match the environment part of the url.
 */
export function searchEnvironmentNameInUrl() {
    const hostname = window && window.location && window.location.hostname

    return /\w+\.(\w+\.)?budbee\.com/.exec(hostname)
}

/**
 * Returns the environment part of the url, e.g: "testing.".
 *
 * Returns an empty string for production or null for localhost.
 *
 * @returns {'testing.' | '' | null} The environment segment of the URL.
 */
export function getUrlEnvironmentSegment() {
    const searchResult = searchEnvironmentNameInUrl()

    // If the regex didn't match, we are in localhost
    if (searchResult === null) {
        return null
    }

    const environmentSegment = searchResult[1] || ''

    if (environmentSegment !== 'testing.') {
        return ''
    }

    return environmentSegment
}

const getBudbeeUrl = (serviceName, environmentSegment) => `https://${serviceName}.${environmentSegment}budbee.com`

export const findWebapiUrlFromHostname = () => {
    const environmentSegment = getUrlEnvironmentSegment()
    return environmentSegment === null ? WEBAPI_LOCALHOST_URL : getBudbeeUrl('webapi', environmentSegment)
}

export const findGroundOpsAdminUrlFromHostname = () => {
    const environmentSegment = getUrlEnvironmentSegment()
    return environmentSegment === null
        ? GROUND_OPS_ADMIN_LOCALHOST_URL
        : getBudbeeUrl('admin.ground-ops', environmentSegment)
}

export const findShoppingBackofficeUrlFromHostname = () => {
    const environmentSegment = getUrlEnvironmentSegment()
    return environmentSegment === null
        ? SHOPPING_BACKOFFICE_LOCALHOST_URL
        : getBudbeeUrl('backoffice.shopping', environmentSegment)
}
